import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10 3.661a.7.7 0 0 0-.38.112l-6.298 4.06a.7.7 0 0 0 0 1.177l6.299 4.06a.699.699 0 0 0 .379.111v-1.533L4.993 8.421 10 5.194V3.661Zm1.063 7.303 3.944-2.543-3.944-2.542V4.213l5.615 3.62a.7.7 0 0 1 0 1.177l-5.616 3.62v-1.667ZM10 14.806l-5.92-3.815a.7.7 0 1 0-.758 1.176l6.299 4.06a.699.699 0 0 0 .379.112v-1.533Zm1.063.98v-1.665l4.857-3.13a.7.7 0 1 1 .758 1.176l-5.616 3.62Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M8.938 3.531a.531.531 0 0 1 1.062 0V16.47a.531.531 0 1 1-1.062 0V3.53Z" />
        <path fill="currentColor" d="m9.241 4.944-5.312 3.5 5.312 3.5v-7Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
